import { isFirefox, numberOfRows, rowSize } from './Constants';

export function scrollToTop() {
    if (isFirefox) {
        window.scrollTo({ top: 0 });
    }
    else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

// Sorts item groups depending on the option the user chose in the interface, as follows:
//     1 = Best Sellers
//     2 = Now Trending
//     3 = Price(Low - High)
//     4 = Price(High - Low)
//     5 = Top Rated
//     6 = Newest
//     7 = Default
export function getSortedItemGroups(itemGroups, sortID) {
    if (!itemGroups) return;

    switch (parseInt(sortID)) {
        case 1:
            //Not defined
            return itemGroups;
        case 2:
            //Not defined
            return itemGroups;
        case 3:
            return itemGroups.sort((a, b) => parseFloat(a.LowestPrice) - parseFloat(b.LowestPrice));
            break;
        case 4:
            return itemGroups.sort((a, b) => parseFloat(b.LowestPrice) - parseFloat(a.LowestPrice));
            break;
        case 5:
            //Not defined
            return itemGroups;
        case 6:
            return itemGroups.sort((a, b) => new Date(+(b.LastModified).replace(/\D/g, '')) - new Date(+(a.LastModified).replace(/\D/g, '')));
            break;
        case 7:
            return itemGroups.sort((a, b) => parseInt(a.SortOrder) - parseInt(b.SortOrder));
            break;
        default:
            return itemGroups;
    }
}

export function getRowSize() {
    if (!window.screen.width) return 4;
    if (window.screen.width >= 992) return 4;
    if (window.screen.width >= 768 && window.screen.width < 992) return 3;
    if (window.screen.width < 768) return 2;
}

export function toggleFilterPanel() {
    var isOpen = $('#mobileFilters').hasClass('slide-in-mobile');
    if (isOpen == false) {
        $('#greyerFilters').show();
        $('#mobileFilters').removeClass('slide-out-mobile');
        $('#mobileFilters').addClass('slide-in-mobile');
        $('#greyerFilters').removeClass('fade-out-mobile');
        $('#greyerFilters').addClass('fade-in-mobile');
    }
    else {
        $('#mobileFilters').removeClass('slide-in-mobile');
        $('#mobileFilters').addClass('slide-out-mobile');
        $('#greyerFilters').removeClass('fade-in-mobile');
        $('#greyerFilters').addClass('fade-out-mobile');
        setTimeout(function () {
            $('#greyerFilters').hide();
        }, 200);
    }
}

export function getBounds(page) {
    const lowerBound = (page - 1) * numberOfRows * rowSize;
    return [lowerBound, Math.min(lowerBound + (numberOfRows * rowSize), model.itemGroupModel.length)];
}

export function getProductSlug(url) {
    if (url) {
        url = url.replace(/[^a-zA-Z 0-9'.@]/g, ' ');  // Remove invalid chars
        url = url.replace(/\s+/g, ' ').trim();        // Trim whitespace
        url = url.replace(/\s/g, "-");                // Whitespace => hyphen
        url = url.replace(/^\-+|\-+$/g, '');          // Remove trailing hyphen
        url = url.replace(/-{2,}/g, '-');             // Remove double hyphens
        return url.toLowerCase();
    }
    return '';
}